// store
import { useSelector, useDispatch, SET_DEVICE } from '../../store';
// styles
import { DevicesList, DevicesButton } from './styles';

// ----------------------------------------------------------------------

export default function Devices({ active }: any) {
  const dispatch = useDispatch();

  const device = useSelector((state) => state.device);
  const devices = useSelector((state) => state.devices);

  const handleSelection = (value: any) => {
    dispatch( SET_DEVICE(value) );
  };

  return (
    <DevicesList $active={active}>
      { devices.map((item: any) => (
        <DevicesButton type='button' key={item.iotDeviceId} onClick={() => handleSelection(item)} $active={device.iotDeviceId === item.iotDeviceId ? true : false}>
          { item.location }
        </DevicesButton>
      ))}
    </DevicesList>
  );
}